import { render, staticRenderFns } from "./head.vue?vue&type=template&id=6e3ee831&scoped=true&"
import script from "./head.vue?vue&type=script&lang=js&"
export * from "./head.vue?vue&type=script&lang=js&"
import style0 from "./head.vue?vue&type=style&index=0&id=6e3ee831&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3ee831",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e3ee831')) {
      api.createRecord('6e3ee831', component.options)
    } else {
      api.reload('6e3ee831', component.options)
    }
    module.hot.accept("./head.vue?vue&type=template&id=6e3ee831&scoped=true&", function () {
      api.rerender('6e3ee831', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/trade/center/head/head.vue"
export default component.exports